import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

const COLORS = ['#13806C',  '#FBBC04','#AF0000',];

// const chartData = [
//   { name: 'Normal', value: 300 },
//   { name: 'Medium', value: 120 },
//   { name: 'High', value: 120 },
// ];

export default function SlaStatusChart({ overViewData }) {
  const safeData = overViewData
    ? Object.entries(overViewData).map(([name, value]) => ({ name, value }))
    : [];
  const renderLegend = ({ payload }) => (
    <ul
      style={{
        display: 'flex',
        justifyContent: 'center',
        gap: 16,
        padding: 0,
        margin: '6px 0 0 0',
        listStyle: 'none',
      }}
    >
      {payload.map((entry, index) => (
        <li
          key={`item-${index}`}
          style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}
        >
          <svg width='10' height='10' style={{ marginRight: 5 }}>
            <circle cx='5' cy='5' r='5' fill={entry.color} />
          </svg>
          {entry.value}
        </li>
      ))}
    </ul>
  );

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.65;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill='white'
        fontSize='12'
        textAnchor='middle'
        dominantBaseline='central'
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <ResponsiveContainer width='100%' height={200}>
      <PieChart margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
        <Pie
          data={safeData}
          label={renderCustomizedLabel}
          cx='50%'
          cy='50%'
          innerRadius={30}
          outerRadius={70}
          labelLine={false}
          fill='#8884d8'
          dataKey='value'
        >
          {safeData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>

        <Legend
          verticalAlign='bottom'
          align='center'
          iconType='circle'
          content={renderLegend}
        />
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
}
